import z from 'zod';

export const lootboxRaritySchema = z.enum(['common', 'uncommon', 'rare', 'epic', 'legendary']);
export type LootboxRarity = z.infer<typeof lootboxRaritySchema>;

const lootboxFields = z.object({
    source: z.string(),
    periodKey: z.string().nullable(),
    timezone: z.string().nullable(),
    resetsAt: z.iso.datetime().nullable(),
    secondsUntilReset: z.number().int().nonnegative().nullable(),
    rarities: z.array(
        z.object({
            rarity: lootboxRaritySchema,
            rewardType: z.literal('boosts'),
            amount: z.number().int().nonnegative(),
            weightBps: z.number().int().min(0).max(10000),
        }),
    ),
});

export const openedLootboxSchema = lootboxFields.extend({
    opened: z.literal(true),
    openedAt: z.iso.datetime(),
    rarity: lootboxRaritySchema,
    rewardType: z.literal('boosts'),
    rewardAmount: z.number().int().nonnegative(),
});
export type OpenedLootbox = z.infer<typeof openedLootboxSchema>;

export const lootboxSchema = z.discriminatedUnion('opened', [
    openedLootboxSchema,
    lootboxFields.extend({
        opened: z.literal(false),
        openedAt: z.null(),
        rarity: z.null(),
        rewardType: z.null(),
        rewardAmount: z.null(),
    }),
]);
export type Lootbox = z.infer<typeof lootboxSchema>;

export const lootboxesResponseSchema = z.object({ lootboxes: z.array(lootboxSchema) });
export const openLootboxResponseSchema = z.object({
    lootbox: openedLootboxSchema,
    boosts: z.number().int().nonnegative(),
    weeklyEarnedBoosts: z.number().int().nonnegative(),
});
